export default {
    toolbarBorderColor: 'black'
};
